import type { NotificationFormValues } from '../../../../../../../notificationForms/sections/notifications/components/NotificationForm'

import { useCallback } from 'react'

import { useResetEditingState } from '@/atoms'
import { updateNotCompletedNotificationConfig } from '@/features/domain/territory'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { convertValues } from '../convertValues'

/**
 * That hook returns a submit method for NotCompletedNotification Form
 */
export function useNotCompletedNotificationSubmit() {
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const onDiscard = useResetEditingState()
  const isUnMounted = useIsUnmounted()

  return useCallback(
    async (formValues: NotificationFormValues) => {
      try {
        const result = await dispatch(
          updateNotCompletedNotificationConfig(convertValues(formValues)),
        )

        if (!updateNotCompletedNotificationConfig.fulfilled.match(result)) {
          throw new Error(result.payload?.message ?? 'Internal error')
        }

        onDiscard()

        if (isUnMounted()) return
      } catch (error) {
        toast.error(error.message)
      }
    },
    [dispatch, toast, onDiscard, isUnMounted],
  )
}
